import useAuth from "@/hooks/useAuth";
import useFetch from "@/hooks/useFetch";
import useTranslation from "@/hooks/useTranslation";
import type { TyApiResponse } from "@/types";
import { formatPhone } from "@/UI/inputs/PhoneInput/formatPhone";
import PhoneInput from "@/UI/inputs/PhoneInput";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";

/** No `isNew` here — an admin account is created by a super admin, never by signing in. */
type TyLoginResponse = TyApiResponse<{ operationId: string }>;

export default function LoginScreen() {
    const t = useTranslation();
    const navigate = useNavigate();
    const token = useAuth((state) => state.token);

    const [phone, setPhone] = useState<string | undefined>(undefined);

    const { data, loading, error, invoke } = useFetch<TyLoginResponse>("auth/login", { method: "POST" }, false);

    useEffect(() => {
        if (token) navigate("/", { replace: true });
    }, [token, navigate]);

    useEffect(() => {
        if (data?.success) navigate("/verify-otp", { state: { operationId: data.data.operationId, phone } });
    }, [data]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const formatted = formatPhone(phone);
        if (!formatted) return;
        invoke({ data: { phone: formatted } });
    };

    return (
        <div className="login-screen">
            <form className="login-card" onSubmit={handleSubmit}>
                <img src="/logo-mini-round.svg" className="login-logo" alt="Menuket" />
                <div className="login-header">
                    <p className="login-title">{t.login.title}</p>
                    <p className="login-subtitle">{t.login.subtitle}</p>
                </div>
                <PhoneInput value={phone} onChange={setPhone} placeholder={t.login.phonePlaceholder} disabled={loading} />
                {error && <p className="login-error">{error}</p>}
                <button type="submit" className="login-submit" disabled={!phone || loading}>
                    {t.login.submitButton}
                </button>
            </form>
        </div>
    );
}
